import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box, Button, CircularProgress, IconButton, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { RootState, useAppDispatch, useAppSelector } from '../../../../../state/state';
import { closeModal, toggleLoading } from '../../../../../state/ModalSlice/ModalSlice';
import { toast } from 'react-toastify';
import { collection, addDoc, writeBatch, doc } from 'firebase/firestore';
import { db } from '../../../../../Config/firebase';

export default function AddBoardModal() {
  const open = useAppSelector((state: RootState) => state.ModalSlice.AddBoardModalOpen);
  const isLoading = useAppSelector((state: RootState) => state.ModalSlice.isLoading);
  const user = useAppSelector((state: RootState) => state.userSliceV2.data);
  const userId = user?.uid || '';
  const dispatch = useAppDispatch();

  const [name, setName] = useState('');

  const handleClose = () => {
    dispatch(closeModal('AddBoardModalOpen'));
    setName('');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!userId) {
      toast.error('User not authenticated');
      return;
    }
    if (!name.trim()) {
      toast.error('Board name is required');
      return;
    }
    try {
      dispatch(toggleLoading(true));
      
      // Create board first
      const boardsRef = collection(db, `ServiceProviders/${userId}/InflowBoards`);
      const boardDoc = await addDoc(boardsRef, {
        name: name.trim(),
        createdAt: Date.now(),
        createdBy: user?.display_name || user?.email || 'Unknown',
      });

      // Create default columns using batch write
      const batch = writeBatch(db);
      const defaultColumns = [
        { title: 'To Initiate', index: 0 },
        { title: 'In Process', index: 1 },
        { title: 'Done', index: 2 }
      ];

      defaultColumns.forEach((column) => {
        const columnRef = doc(collection(db, `ServiceProviders/${userId}/InflowBoards/${boardDoc.id}/Columns`));
        batch.set(columnRef, {
          ...column,
          createdAt: Date.now(),
        });
      });

      await batch.commit();
      
      toast.success('Board created with default columns!');
      handleClose();
    } catch (e) {
      console.error(e);
      toast.error('Failed to create board');
    } finally {
      dispatch(toggleLoading(false));
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, borderBottom: '1px solid rgba(0,0,0,0.12)' }}>
        <Typography variant="h6">Create Board</Typography>
        <IconButton onClick={handleClose} size="small"><CloseIcon /></IconButton>
      </Box>
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField fullWidth label="Board name" value={name} onChange={(e) => setName(e.target.value)} disabled={isLoading} />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 2 }}>
            This will create a board with three default columns: "To Call", "Reminded", and "Done"
          </Typography>
          <Button type="submit" variant="contained" sx={{ mt: 2 }} fullWidth disabled={isLoading} startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}>Create</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}


